import { Button, Flex, Paper, Text } from "@pillar-ui/core";
import {
  useAppStateContext,
  useFilterStateContext,
  useSortingStateContext,
} from "../common/contexts";
import {
  SORT_BY_AZ,
  SORT_BY_DISTANCE,
  SORT_BY_PRICE,
  SORT_TYPE,
} from "../common/constants";
import {
  ChevronDown,
  ChevronTop,
  Repeat,
  SortAscending,
  SortDescendingLetters,
} from "@pillar-ui/icons";
import colors from "../styles/colors";

export const Sortings = () => {
  const {
    sortByAZ,
    sortByDistance,
    sortByPrice,
    setFocusSortType,
    setSortByAZ,
    setSortByDistance,
    setSortByPrice,
  } = useSortingStateContext();
  const { setFilterById } = useFilterStateContext();
  const { totalLength } = useAppStateContext();

  return (
    <Paper
      p="3"
      background="Se5"
      style={{
        position: "sticky",
        left: 0,
        top: 150,
        zIndex: 99,
        paddingTop: 8,
        paddingBottom: 8,
        boxShadow: `0 8px 10px -5px hsl(43, 29.9%, 85.7%)`,
      }}
    >
      <Flex direction="row" wrap gap="5" items="center">
        <Paper
          as={Flex}
          items="center"
          justify="center"
          onClick={() => {
            setFocusSortType(SORT_TYPE.AZ);
            setSortByAZ(
              sortByAZ === SORT_BY_AZ.ASCENDING
                ? SORT_BY_AZ.DESCENDING
                : SORT_BY_AZ.ASCENDING
            );
          }}
        >
          {sortByAZ === SORT_BY_AZ.ASCENDING ? (
            <SortAscending width={20} height={20} strokeWidth={1.5} />
          ) : (
            <SortDescendingLetters width={20} height={20} />
          )}
        </Paper>
        <Paper
          onClick={() => {
            setFocusSortType(SORT_TYPE.PRICE);
            setSortByPrice(
              sortByPrice === SORT_BY_PRICE.ASCENDING
                ? SORT_BY_PRICE.DESCENDING
                : SORT_BY_PRICE.ASCENDING
            );
          }}
        >
          <Flex gap="1" items="center">
            <Text size="3" weight="5">
              Giá
            </Text>
            {sortByPrice === SORT_BY_PRICE.ASCENDING ? (
              <ChevronDown width={14} height={14} strokeWidth={2} />
            ) : (
              <ChevronTop width={14} height={14} strokeWidth={2} />
            )}
          </Flex>
        </Paper>
        <Paper
          onClick={() => {
            setFocusSortType(SORT_TYPE.DISTANCE);
            setSortByDistance(
              sortByDistance === SORT_BY_DISTANCE.NEAREST
                ? SORT_BY_DISTANCE.FURTHEST
                : SORT_BY_DISTANCE.NEAREST
            );
          }}
        >
          <Flex gap="1" items="center">
            <Text size="3" weight="5">
              Khoảng cách
            </Text>
            {sortByDistance === SORT_BY_DISTANCE.NEAREST ? (
              <ChevronDown width={14} height={14} strokeWidth={2} />
            ) : (
              <ChevronTop width={14} height={14} strokeWidth={2} />
            )}
          </Flex>
        </Paper>
        <Paper style={{ flex: 1, textAlign: "end" }}>
          <Button
            onClick={() => {
              const newIndex = Math.floor(
                ((Math.random() * Date.now()) % 1) * (totalLength - 1)
              );
              setFilterById(newIndex);
            }}
            icon={<Repeat />}
            variant="mixed"
            style={{ width: 140, maxWidth: "35%" }}
          >
            Ngẫu nhiên
          </Button>
        </Paper>
      </Flex>
    </Paper>
  );
};

export default Sortings;
